/**
 * 土耳其语（tr-TR）
 */

import trTRLocale from 'element-ui/lib/locale/lang/tr-TR'

export default {
  ...trTRLocale,
  common: {},
  // 语言
  lang: {
    english: 'English',
    spanish: 'İspanyolca',
    japanese: 'Japanese',
    portuguese: 'Portekizce',
    french: 'French',
    russian: 'Rusça',
    arabic: 'Arabic',
    german: 'Almanca',
    italian: 'İtalyanca',
    vietnam: 'Vietnam',
    turkey: 'Türkiye',
    korean: 'Korece',
    thai: 'Thai',
    dutch: 'Dutch',
    hebrew: 'İbraniyce',
    indonesian: 'Indonezi'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
